import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Select from "react-select";
import {
  setClientBranchActions,
  SetThesendNotificationCreateActions,
  getSideBarfilesActions,
  SetVerifiedUserActions,
  setTheActionsBoth_theusers,
  SetClientActions,
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,

} from "../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import useDebouncedEffect from 'use-debounced-effect';

const SendNotifi = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const initialState = {
    title: "",
    body: "",
    client_id: "",
    user_id: "",
    send_type: "",
    white_collar: "",
    parent:""
  };
  const [clientvalues , setclientalues] = useState([]);

  const [datas, setDatas] = useState(initialState);
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "QPMS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  const [EMpROleSelected, setEmpRoleSele] = useState(EmpRoles[0]);

  const [filterForWhite, setFilters] = useState({ white_collar: "" });
  const [OldEmp, setOldEMp] = useState({
    label: "ALL",
    value: "",
  });

  const oldemloyeeOptions = [
    {
      value: "",
      label: "ALL",
    },
    {
      value: true,
      label: "EXISTING EMPLOYEE",
    },
    {
      value: false,
      label: "NEW EMPLOYEE",
    },
  ];

  const [oldemplo, setoldemp] = useState({ old_employee: "" });

  const [nameListclient, setOptionsclient] = useState([]);
  const [nameListclientParent, setOptionsclientParent] = useState([]);
  const [data, setData] = useState({
    zone: "",
    state: state.ClientBranchIDs.StateName.value,
    region: "",
  });


  const navigate = useNavigate();
  const [nameList4, setOptions4] = useState([]);
  const [nameList1, setOptions1] = useState([]);

  const [selectedValues, SetSelectValue] = useState([]);
  const [titelerr, setTitelErr] = useState("");
  const [clientSelectval, setclientSel] = useState();
  const [bodyErr, setBodyErr] = useState("");
  const [userErr, setUserErr] = useState("");
  const [clientErr, setClientErr] = useState();
  const [selectedusers, setselecteduser] = useState([]);
  let Ids = [];
  const [Client, setClients] = useState();
  const initialStateSearch = {
    client: "",
    Employeesearch: "",
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Employeesearch: "",
    client: "",
    parent:""
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    client: "",
    Employeesearch: "",
    parent:""


};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);


  const [EmpDAta, setEmpdatas] = useState([]);
  const initialStateSearchval = {
    client: "",
    parent:""
  };
  const [SearchedValclient, setSearchedclient] = useState(
    initialStateSearchval
  );
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "All" }
    state.ClientBranchIDs.StateName,
  ]);
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([]);
  const [multiselect3, setMuliselect3] = useState([]);
  const [Zone, setZone] = useState([]);
const [zoneoptions , setoptionzone] = useState([])
  
const handleInputChangeClinet = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    client: Val,
  });

};

  const handleInputChangeEmployeesearch = (val) => {
    setSearchDebounance({
      ...SearchDebounance,
      Employeesearch: val,
    });
  }
  const HandleChanges = (e) => {
    setDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setData({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null && data.state == null && data.zone == null) {
      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setData({
        ...data,
        region: "",
        zone: "",
      });

      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
    }
  };

  //----Handle----Remove -----in----Regions
  const handleRemove = (e) => {
    setMuliselect1(e);
    setData({
      ...data,
      region: "",
    });
  };

  //----------------Zone
  const handleZone = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });
    }
    if (selectedVal == null && data.region == null && data.state == null) {
      setData({
        ...data,
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect3({ value: "search", label: "Search" });
    }
  };
  //---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
  });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };
   ///----State----------Changes-----------------------
   const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
      setDatas({
        ...datas,
        client_id: "",
      });
    }

    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "search", label: "Search" });
      setMuliselect3({ value: "search", label: "Search" });
      setData({
        ...data,
        state: "",
        region: "",
        zone: "",
      });
      setDatas({
        ...datas,
        client_id: "",
      });
    }
  };



  const HandleClientParents = (selectedVal) => {
    if (selectedVal != null) {
      setclientalues(selectedVal)
      setDatas({
        ...datas,
        parent: selectedVal.value,
        client_id:""
      });
    } else {
      setclientalues({value:"",label:"Select"})
      setDatas({
        ...datas,
        parent: "",
        client_id:""
      });
    }
  };

  useEffect(() => {
    const payload = {
      search: SearchedVal.client,
      page_size: 10,
      page: 1,
    };
    dispatch(setClientBranchActions(payload)); ///----branch--------
  }, [SearchedVal.client]);
  useEffect(() => {
    const payloads = {
      search: SearchedVal.Employeesearch,
      page_size: 20,
      page: 1,
      client: filterForWhite.white_collar == true ? "" :datas.client_id,
      parent:filterForWhite.white_collar == true ? "" :datas.parent,
      white_collar:filterForWhite.white_collar,
      is_oldemployee:OldEmp.value
    };

    dispatch(setTheActionsBoth_theusers(payloads));

  }, [datas.client_id, datas.parent ,SearchedVal.Employeesearch, filterForWhite , OldEmp,]);
  useEffect(() => {
    const payload = {
      search: SearchedValclient.parent,
      page_size: 20,
      page: 1,
    };
    dispatch(SetClientActions(payload));
  }, [SearchedValclient.parent, data]);
  useEffect(() => {
    if (state.ClientList.ClientLists != undefined) {
      let objectArray = [];
    state.ClientList.ClientLists.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptionsclientParent(objectArray);
    }
  }, [state.ClientList.ClientLists, SearchedValclient.parent]);


    ///--------------State-----------------
    useEffect(() => {
      const payloads = {
        search: SearchedVal.stateSearch,
        page_size: "",
        page: 1,
      };
      dispatch(setGeoLoactionStateAction(payloads));
    }, [SearchedVal.stateSearch]);
    //--------------_Zone---------------
    useEffect(() => {
      const payloads = {
        search: SearchedVal.zoneSearch,
        page_size: 20,
        page: 1,
        counts: 1,
        region_id: data.region,
      };
      dispatch(setZoneActions(payloads));
    }, [data.region, SearchedVal.zoneSearch]);

  useEffect(() => {
    if (state.bothuserASEmployeee.boththeEmployeeandUDS != undefined) {
      let objectArray = [];
      setEmpdatas(state.bothuserASEmployeee.boththeEmployeeandUDS);
      state.bothuserASEmployeee.boththeEmployeeandUDS.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.first_name,
        });
      });
      setOptions1(objectArray);
    }
  }, [state.bothuserASEmployeee.boththeEmployeeandUDS ,datas.client_id, datas.parent ,SearchedVal.Employeesearch, filterForWhite , OldEmp,]);



  useEffect(() => {
    if (state.ClientBranch.ClientBranchess != undefined) {
      let objectArray = [];
      state.ClientBranch.ClientBranchess.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ClientBranch.ClientBranchess, SearchedVal.client]);

  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  //---------------State0------------------------
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setoptionzone(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  const HandleClientBranches = (selectedVal) => {
    console.log(selectedVal.value, "va;lusfodcn ");
    setclientSel(selectedVal);
    setDatas({
      ...datas,
      client_id: selectedVal.value,
    });
  };

  const handleUserIDs = (selectedVal) => {
    setselecteduser(selectedVal);
    const listids = [];
    selectedVal.forEach((element) => {
      listids.push(element.value);
    });
    console.log(listids, "listids");
    setDatas({
      ...datas,
      user_id: listids,
    });
  };

  useEffect(() => {
    if (selectedValues != []) {
      selectedValues.map((item) => {
        Ids.push(item.value);
      });
      setClients(Ids);
    }
  }, [selectedValues]);

  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);

      if (e.value == 1) {
        // dispatch(setaRoleChnage(1));
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
        setDatas({
          ...datas,
          parent:"",
          client_id: "",

        })
        setclientalues({label:"Select",value:""});

        setclientSel({label:"Select",value:""});

      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
      }
    }
  };

   const HandleTheOldEmployee =(e)=>{
    if (e != null) {
      setOldEMp(e);
      setoldemp({
        ...oldemplo,
        old_employee: e.value,
      });

    }
   }
   const handleInputChangeClinetParent =(e)=>{
    setSearchDebounance({
      ...SearchDebounance,
      parent: e,
    });
   }

   useDebouncedEffect(
    () => {
      if (setSearchDebounance) {

        setSearchedclient({
          ...SearchedValclient,
          parent: SearchDebounance.parent,
          client: SearchDebounance.client
        });
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
          client: SearchDebounance.client,
          Employeesearch:SearchDebounance.Employeesearch

      });
      }
    },
    500,
    [SearchDebounance]
  );

  ///----Submits---------------
  const HandleSubmit = (e, values) => {
    var a = 0;
    if (values == "single") {
      if (datas.client_id == ""&& filterForWhite.white_collar !="" && filterForWhite.white_collar == false) {
        setClientErr("*Client is required");
        a = 1;
      }

      if (!datas.user_id || datas.user_id.length === 0) {
        setUserErr("*Employee is required");
        a = 1;
      }
          }
    if (datas.body == "") {
      a = 1;
      setBodyErr("*Description is required");
    }

    if (datas.title == "") {
      a = 1;
      setTitelErr("*Title is required");
    }

    console.log(a ,"wpe8oqwieopiqwe");
    

    if (a == 0) {
      const payload = {
        data: datas,
        Client: Client,
        send_type: values,
        filters:data,
        white_collar:filterForWhite.white_collar,
        is_oldemployee:OldEmp.value

      };
      dispatch(SetThesendNotificationCreateActions(payload));
      setDatas({ ...datas, client_id: "", user_id: [], body: "", title: "" });
      setselecteduser([])
      setclientSel({});
      setOldEMp({
        label: "ALL",
        value: "",
      });
      setEmpRoleSele(EmpRoles[0]);
      setMuliselect([]);
      setMuliselect1([]);
      setMuliselect3([]);
      setData({
        ...data,
        state:"",
        zone:"",
        region:""
      })

    }
  };

   console.log(datas , data, OldEmp.value ,"asldasjdlkajsdl",filterForWhite);
   

  return (
    <>
      <div className={stateDisplay ? " POPUP" : "outerPOPUP"}>
        <div className="col BodyContent">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div class="ModalHeader">
                      <span className="UserCreate"> Mass Communication </span>
                    </div>
                  </div>
                </div>

                <div className="Modal-Body">
                  <div className="row Filters">
                    <div class="col-sm-3 mt-4 field-div">
                      <label
                        for="validationCustom01"
                        class="form-label"
                        style={{ fontSize: "15px" }}
                      >
                        Title
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        autoComplete="off"
                        onChange={(e) => {
                          setTitelErr("");
                          HandleChanges(e);
                        }}
                        required
                        name="title"

                        value={datas.title}
                      ></input>

                      <p style={{ color: "red", marginTop: "5px" }}>
                        {titelerr}
                      </p>
                    </div>
                    <div className="col-sm-3 mt-4">
                          <label for="validationCustom01" class="form-label">
                            State 
                          </label>
                          <Select
                            styles={{ position: "relative", zIndex:"88",top: "60px" }}
                            className="Selects"

                            onSelect={(e) => {
                              setMuliselect(e);
                            }}
                            onChange={(e) => {
                              setMuliselect1([]);
                              setMuliselect3([]);
                              handleSelectChange(e);
                            }}
                            isClearable={true}
                            options={nameList}
                            onremoved={(e) => {
                              setMuliselect(e);
                            }}
                            onInputChange={(Val) => {
                              setSearchDebounance({
                                ...SearchDebounance,
                                stateSearch: Val,
                            });
                            }}
                            labelledBy="Select"
                            value={multiselect}
                          />
                        </div>
                        <div className="col-sm-3 mt-4">
                          <label for="validationCustom01" class="form-label">
                            Region 
                          </label>
                          <Select
                                                    className="Selects"

                                                    styles={{ position: "relative", zIndex:"88",top: "60px" }}
                                                    onSelect={(e) => setMuliselect1(e)}
                            onChange={(e) => {
                              setMuliselect3([]);
                              handelRegionSlect(e);
                            }}
                            options={nameList2}
                            labelledBy="Select"
                            isClearable={true}
                            onremoved={(e) => {
                              handleRemove(e);
                            }}
                            value={multiselect1}
                            onInputChange={handleInputRegion}
                          />
                        </div>
                        <div className="col-sm-3 mt-4">
                          <label for="validationCustom01" class="form-label">
                            Zone 
                          </label>
                          <Select
                                                    className="Selectsmass"

                                                    styles={{ position: "relative",top: "60px" }}
                                                    onSelect={(e) => setMuliselect3(e)}
                            onChange={(e) => {
                              handleZone(e);
                            }}
                            options={zoneoptions}
                            isClearable={true}
                            onremoved={(e) => {
                              setMuliselect3(e);
                            }}
                            value={multiselect3}
                            onInputChange={handleInputZone}
                            labelledBy="Select"
                          />
                        </div>

                        <div
                        className="col-sm-3 mt-4"
                      >
                         <label for="validationCustom01" class="form-label">
                              Client parent
                            </label>
                            <Select
                                                      className=" Selectsmass"

                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                HandleClientParents(e);
                              }}
                              isDisabled={
                                filterForWhite.white_collar === true
                                }
                              isClearable="true"
                              options={nameListclientParent}
                              onInputChange={handleInputChangeClinetParent}
                              placeholder="search"
                               value={clientvalues}
                            />

                      </div>

                      <div
                        className="col-sm-3 mt-4"
                      >
                        <label for="validationCustom01" class="form-label">
                          Branch
                        </label>


                        <Select
                          // className="Selects"
                          styles={{
                            position: "relative",
                            top: "60px",
                            padding: "70vh",
                          }}
                          value={clientSelectval}
                          onChange={(e) => {
                            HandleClientBranches(e);
                            setClientErr("");
                          }}
                          isDisabled={
                            filterForWhite.white_collar === true
                            }
                                              filterOption={() => true}   

                                                    options={nameList4}
                          onInputChange={handleInputChangeClinet}
                          placeholder="search"
                        />

                      </div>

                      <div
                        className="col-sm-3 mt-4"
                      >
                        <label for="validationCustom01" class="form-label">
                          Employee Designation
                        </label>
                        <Select
                          // className="Selects"
                          styles={{
                            position: "relative",
                            top: "60px",
                            padding: "70vh",
                          }}
                          value={EMpROleSelected}
                          onChange={(e) => {
                            HandleEMprole(e);
                          }}
                          options={EmpRoles}
                          placeholder="search"
                        />

                      </div>
                      <div
                        className="col-sm-3 mt-4"
                      >
                        <label for="validationCustom01" class="form-label">
                          Employee
                        </label>


                        <Select
                          className="Selects"
                          styles={{
                            position: "relative",
                            top: "60px",
                            padding: "70vh",
                          }}
                          value={OldEmp}
                          onChange={(e) => {
                            HandleTheOldEmployee(e);
                            setClientErr("");
                          }}
                          options={oldemloyeeOptions}
                          placeholder="search"
                        />


                      </div>
                      <div
                        className="col-sm-3 mt-4"
                      // style={{ zIndex: "20", marginLeft: "2px" }}
                      >
                        <label for="validationCustom01" class="form-label">
                          Employee List
                          {/* <span style={{ color: "red" }}>*</span> */}
                        </label>

                        <Select
                          className="Selects"
                          styles={{
                            position: "relative",
                            top: "60px",
                            padding: "70vh",
                          }}
                          onChange={(e) => {
                            handleUserIDs(e);
                            setUserErr("")
                          }}
                          options={nameList1}
                          isMulti
                          value={selectedusers}
                          onInputChange={handleInputChangeEmployeesearch}
                          placeholder="search"
                        />
                        <p style={{ color: "red", marginTop: "5px" }}>
                          {userErr}
                        </p>
                      </div>
                      
                    <div class="col-sm-3 mt-3 field-div">
                      <label
                        for="validationCustom01"
                        class="form-label"
                        style={{ fontSize: "15px" }}
                      >
                        Description
                        <span style={{ color: "red" }}>*</span>

                      </label>
                      <textarea
                        class="form-control"
                        autoComplete="off"
                        onChange={(e) => {
                          HandleChanges(e);
                          setBodyErr("");
                        }}
                        required
                        name="body"
                        style={{

                          height: "75px"
                        }}
                        value={datas.body}
                      ></textarea>

                      <p style={{ color: "red", margin: "0px 5px", marginBottom: "10px" }}>
                        {bodyErr}
                      </p>
                    </div>


                  </div>

                  <div
                    className="row"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignContent: "end",
                      marginTop: "15px",
                    }}
                  >
                    {/* <div
                      className="col-6 mt-3"
                      style={{ zIndex: "20", marginLeft: "2px" }}
                    >
                      <label for="validationCustom01" class="form-label">
                        Employee List
                      </label>

                      <Select
                        className="Selects"
                        styles={{
                          position: "relative",
                          top: "60px",
                          padding: "70vh",
                        }}
                        onChange={(e) => {
                          handleUserIDs(e);
                        }}
                        options={nameList1}
                        isMulti
                        value={selectedusers}
                        // onInputChange={handleInputChangeClinet}
                        placeholder="search"
                      />
                      <p style={{ color: "red", marginTop: "5px" }}>
                        {userErr}
                      </p>
                    </div> */}
                  </div>
                  <div
                    className="RoleButton"
                    style={{
                      display: "flex",
                      gap: "15px",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "30px",
                    }}
                  >
                    <div style={{ display: "flex", gap: "20px" }}>
                      <button
                        class="btn  SaveBtn"
                        type="submit"
                        onClick={(e) => {
                          HandleSubmit(e, "single");
                        }}
                      >
                        {/* Send Notification */}
                        Mass Communication
                      </button>

                      <button
                        class="btn  SaveBtn"
                        type="submit"
                        onClick={(e) => {
                          HandleSubmit(e, "all");
                        }}
                      >
                        Mass Communication All
                        {/* Send Notification All */}
                      </button>
                    </div>

                    <button
                      class="btn CancelBtn"
                      onClick={(e) => {
                        navigate("/");
                        dispatch(getSideBarfilesActions("DashBoard"));
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendNotifi;
